<template>
  <div>
    <div class="results_container">
      <div class="block" id="expertSearchBar">
        <div class="block-header expert-search-bar">
          <div class="expert-search-bar__left">
            <div class="input-group input-group-sm expert-search-bar__input-wrap">
              <input v-model="searchStr" type="text" class="form-control form-control-alt search-project" placeholder="Expert Search..." />
              <div class="input-group-append">
                <span class="input-group-text bg-body border-0">
                  <i class="si si-magnifier" />
                </span>
              </div>
            </div>
            <div class="d-flex flex-column">
              <label class="mb-0 small text-muted" for="expert-phone-filter">Phone status</label>
              <b-form-select
                id="expert-phone-filter"
                v-model="phoneFilter"
                size="sm"
                class="expert-search-bar__phone-filter"
                @change="onPhoneFilterChange"
              >
                <b-form-select-option :value="null">All Experts</b-form-select-option>
                <b-form-select-option value="has_phone">Has Phone</b-form-select-option>
                <b-form-select-option value="no_phone">No Phone</b-form-select-option>
              </b-form-select>
            </div>
            <div class="d-flex flex-column expert-search-bar__staff-filter-wrap">
              <label class="mb-0 small text-muted" for="expert-staff-filter">Added by</label>
              <b-form-select
                id="expert-staff-filter"
                v-model="staffFilter"
                size="sm"
                class="expert-search-bar__staff-filter"
                @change="onStaffFilterChange"
              >
                <b-form-select-option :value="null">All Staff</b-form-select-option>
                <b-form-select-option v-for="staff in staffOptions" :key="staff.value" :value="staff.value">
                  {{ staff.text }}
                </b-form-select-option>
              </b-form-select>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-secondary expert-search-bar__clear"
              :disabled="!hasActiveFilters"
              @click="clearAllFilters"
            >
              Clear all
            </button>
          </div>
          <div class="expert-search-bar__right">
            <b-dropdown
              size="sm"
              variant="primary"
              right
              :disabled="exportAllLoading || exportSelectedLoading"
              toggle-class="d-flex align-items-center"
            >
              <template #button-content>
                <i :class="(exportAllLoading || exportSelectedLoading) ? 'fa fa-spinner fa-spin me-1' : 'si si-download me-1'"></i>
                Export Experts
              </template>
              <b-dropdown-item
                href="#"
                :disabled="exportSelectedLoading || selectedExpertIds.length === 0"
                @click.prevent="exportSelectedExperts"
              >
                <i :class="exportSelectedLoading ? 'fa fa-spinner fa-spin me-1' : 'si si-download me-1'"></i>
                Export Selected ({{ selectedExpertIds.length }})
              </b-dropdown-item>
              <b-dropdown-item
                href="#"
                :disabled="exportAllLoading"
                @click.prevent="exportExperts"
              >
                <i :class="exportAllLoading ? 'fa fa-spinner fa-spin me-1' : 'si si-download me-1'"></i>
                Export All Experts
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>

      <div v-if="loading" class="d-flex justify-content-center mb-3">
        <b-spinner style="width: 3rem; height: 3rem" type="grow" label="Fetching Experts" variant="primary" />
      </div>
      <div v-else>
        <expert-result-block
          v-for="user in usersComputed"
          :key="user.id"
          :user="user"
          :current-route-name="currentRouteName"
          :routes="routesComputed"
          :wpmessage="wpmessageComputed"
          :hide-job-experiences="hideJobExperiencesComputed"
          :me="meComputed"
          :all-assignment-statuses="allAssignmentStatusesComputed"
          :project="project"
          :questions="questions"
          :project-staffs="projectStaffs"
          :user-logged-id="userLoggedId"
          @updated="getUsers"
          @expert-checked="handleExpertChecked"
        />

        <vue-pagination :data="$store.state.expert.usersExpertsObj" @pagination-change-page="getUsers" />
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "../../../mixins/mixin";
import axios from "axios";

export default {
  name: "ExpertSimpleList",
  mixins: [mixin],
  props: {
    usersInit: {
      type: String,
      required: true,
    },
    currentRouteName: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    allAssignmentStatusesInit: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    attachedJobExperienceIdsInit: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    projectInit: {
      type: String,
      required: false,
      default() {
        return null;
      },
    },
    questionsInit: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    projectStaffs: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    userLoggedId: {
      type: Number,
      required: false,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      url: "/admin/experts/api/index",
      users: {},
      wpmessage: "",
      extraStringRaw: "",
      hideJobExperiences: false,
      searchStr: "",
      phoneFilter: null,
      staffFilter: null,
      myUser: {},
      routes: [],
      allAssignmentStatuses: [],
      attachedJobExperienceIds: [],
      project: {},
      questions: [],
      loading: false,
      selectedExpertIds: [],
      exportAllLoading: false,
      exportSelectedLoading: false,
    };
  },
  computed: {
    usersComputed() {
      return this.$store.state.expert.usersExpertsObj.data;
    },
    routesComputed() {
      return this.routes || [];
    },
    wpmessageComputed() {
      return this.wpmessage || "";
    },
    extraString() {
      return this.extraStringRaw;
    },
    total() {
      return this.users.total || 0;
    },
    hideJobExperiencesComputed() {
      return this.$store.state.expert.hideJobExperiencesComputed;
    },
    meComputed() {
      return this.myUser;
    },
    allAssignmentStatusesComputed() {
      return this.allAssignmentStatuses || [];
    },
    staffOptions() {
      return (this.projectStaffs || [])
        .map((staff) => ({
          value: staff.id,
          name: staff.user ? `${staff.user.first_name} ${staff.user.last_name}`.trim() : `Staff #${staff.id}`,
          count: staff.added_experts_count || 0,
        }))
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((staff) => ({ value: staff.value, text: `${staff.name} (${staff.count})` }));
    },
    hasActiveFilters() {
      return this.searchStr.length > 0 || this.phoneFilter != null || this.staffFilter != null;
    },
  },
  watch: {
    searchStr: async function (value, oldVal) {
      if (value.length >= 2 || (oldVal.length > value.length && value.length === 0)) {
        this.$store.commit("expert/setExpertKeyword", value);
        this.searchString();
      }
    },
  },
  mounted() {
    const users = JSON.parse(this.usersInit);
    this.$store.commit("expert/setUsersExpertsObj", users);
    this.project = JSON.parse(this.projectInit);
    this.questions = JSON.parse(this.questionsInit);
    this.allAssignmentStatuses = this.allAssignmentStatusesInit.length > 0 ? JSON.parse(this.allAssignmentStatusesInit) : [];
    this.attachedJobExperienceIds = this.attachedJobExperienceIdsInit.length > 0 ? JSON.parse(this.attachedJobExperienceIdsInit) : [];
    this.getMyUser().then((u) => (this.myUser = u));

    if (window.NodesPermissions.length === 0) {
      this.getPermittedRoutes().then((res) => {
        this.routes = res;
        this.$store.commit("routes/setRoutePermissions", res);
      });
    } else {
      this.routes = window.NodesPermissions;
      this.$store.commit("routes/setRoutePermissions", window.NodesPermissions);
    }
    this.getSingleWpMessage("expert.whatsapp_preset_message1").then((res) => (this.wpmessage = res));

    this.phoneFilter = this.$store.state.expert.expertHasPhoneFilter;
    this.staffFilter = this.$store.state.expert.expertAddedByStaffFilter;

    //get payment request of this project
    this.$store.dispatch("project/payment/getRequestSentList", { projectId: this.project.id, staffId: this.userLoggedId });
  },
  methods: {
    searchString: _.debounce(function () {
      this.getUsers();
    }, 300),
    onPhoneFilterChange(value) {
      this.$store.commit("expert/setExpertHasPhoneFilter", value);
      this.getUsers(1);
    },
    onStaffFilterChange(value) {
      this.$store.commit("expert/setExpertAddedByStaffFilter", value);
      this.getUsers(1);
    },
    clearAllFilters() {
      if (!this.hasActiveFilters) {
        return;
      }
      const shouldRefetchFromWatcher = this.searchStr.length > 0;
      this.phoneFilter = null;
      this.staffFilter = null;
      this.$store.commit("expert/setExpertHasPhoneFilter", null);
      this.$store.commit("expert/setExpertAddedByStaffFilter", null);
      this.$store.commit("expert/setExpertKeyword", "");
      if (shouldRefetchFromWatcher) {
        this.searchStr = "";
      } else {
        this.getUsers(1);
      }
    },
    markString(str) {
      this.searchStr = str;
    },
    async getUsers(page = 1) {
      this.loading = true;
      await this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id, page: page });
      this.loading = false;
    },
    setDisplayOptions(payload) {
      if (payload && payload.id === "hideJobExperiences") {
        this.hideJobExperiences = payload.status;
      }
    },
    handleExpertChecked(payload) {
      const { expertId, checked } = payload;
      if (checked) {
        if (!this.selectedExpertIds.includes(expertId)) {
          this.selectedExpertIds.push(expertId);
        }
      } else {
        const index = this.selectedExpertIds.indexOf(expertId);
        if (index > -1) {
          this.selectedExpertIds.splice(index, 1);
        }
      }
    },
    async exportExperts() {
      if (!this.project || !this.project.id) {
        return;
      }

      try {
        this.exportAllLoading = true;
        const url = `/api/v1/projects/${this.project.id}/export-experts`;
        const response = await axios.post(url, {}, {
          responseType: 'blob'
        });

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        let filename = 'experts.xlsx';
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/);
          if (filenameMatch) {
            filename = filenameMatch[1];
          }
        }

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error('Export failed:', error);
        alert('Export failed. Please try again.');
      } finally {
        this.exportAllLoading = false;
      }
    },
    async exportSelectedExperts() {
      if (!this.project || !this.project.id || this.selectedExpertIds.length === 0) {
        return;
      }

      try {
        this.exportSelectedLoading = true;
        const url = `/api/v1/projects/${this.project.id}/export-experts`;
        const response = await axios.post(url, {
          expertIds: this.selectedExpertIds
        }, {
          responseType: 'blob'
        });

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        let filename = 'experts.xlsx';
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/);
          if (filenameMatch) {
            filename = filenameMatch[1];
          }
        }

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        this.selectedExpertIds = [];

        this.$emit('reset-checkboxes');
      } catch (error) {
        console.error('Export failed:', error);
        alert('Export failed. Please try again.');
      } finally {
        this.exportSelectedLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.expert-search-bar {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: stretch;
}
.expert-search-bar__left {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: stretch;
}
.expert-search-bar__input-wrap {
  max-width: 100%;
}
.expert-search-bar__phone-filter {
  flex-shrink: 0;
  width: auto !important;
  min-width: 130px;
}
.expert-search-bar__staff-filter {
  flex-shrink: 0;
  width: auto !important;
  min-width: 160px;
}
.expert-search-bar__clear {
  align-self: flex-end;
  flex-shrink: 0;
}
.expert-search-bar__right {
  display: flex;
  justify-content: flex-start;
}
@media (min-width: 768px) {
  .expert-search-bar {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .expert-search-bar__left {
    flex-direction: row;
    align-items: center;
    gap: 0;
  }
  .expert-search-bar__input-wrap {
    max-width: 300px;
    margin-right: 0.5rem;
  }
  .expert-search-bar__staff-filter-wrap {
    margin-left: 0.5rem;
  }
  .expert-search-bar__clear {
    margin-left: 0.5rem;
  }
  .expert-search-bar__right {
    justify-content: flex-end;
  }
}
</style>
